import { Component, OnInit, Inject } from "@angular/core";

import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-quick-view-modal",
  templateUrl: "./quick-view-modal.component.html",
  styleUrls: ["./quick-view-modal.component.css"],
})
export class QuickViewModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {}

  isArray(value: string | string[]): boolean {
    return Array.isArray(value);
  }

  parseText(input: string | string[]): string {
    if (!Array.isArray(input)) return input || "";

    let output = "";

    input.forEach((value, index) => {
      let text = `<span>${value}</span>` || "";
      if (index > 0 && text) {
        text = "<br/>" + text;
      }
      output += text;
    });

    return output;
  }
}
